import { Info, Plus } from 'lucide-react';

type GalleryHeaderProps = {
  canUpload: boolean;
  onUpload: () => void;
};

export function GalleryHeader({ canUpload, onUpload }: GalleryHeaderProps) {
  return (
    <>
      <header className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="text-left">
          {/* <p className="m-0 text-[11px] font-semibold tracking-[0.12em] text-[var(--dash-brand)] uppercase">
            Library
          </p> */}
          <h1 className="m-0 mt-1 text-2xl font-semibold tracking-tight text-[var(--dash-ink)]">
            Pre-Approved Gallery
          </h1>
          <p className="mt-1 mb-0 text-sm text-[var(--dash-muted)]">
            Upload creatives once and reuse them while creating campaigns.
          </p>
        </div>

        {canUpload ? (
          <button
            type="button"
            onClick={onUpload}
            className="dash-btn-gradient inline-flex items-center justify-center gap-2 self-start rounded-2xl px-4 py-2.5 text-sm font-semibold text-white"
          >
            <Plus className="h-4 w-4" />
            Add content
          </button>
        ) : null}
      </header>

      <div className="flex items-start gap-2.5 rounded-2xl border border-[#DBEAFE] bg-[#EFF6FF] px-4 py-3 text-left">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-[var(--dash-brand)]" />
        <p className="m-0 text-sm leading-relaxed text-[#1E40AF]">
          <span className="font-semibold">Note:</span> You can upload content
          anytime and use it directly while creating a campaign.
        </p>
      </div>
    </>
  );
}
